import React from 'react';
import { ComponentWithAs, Flex, FlexProps, forwardRef, useDisclosure } from '@chakra-ui/react';
import Ppussung from '../atom/Ppussung';
import CreditModal from './CreditModal';
import ClickBalloon from '../atom/ClickBalloon';
import { motion, MotionProps } from 'framer-motion';

const MotionFlex = motion<FlexProps>(Flex);

const CreditButtonSection: ComponentWithAs<'div', MotionProps & FlexProps> = forwardRef<
  MotionProps & FlexProps,
  'div'
>((props, ref) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <MotionFlex
      as='button'
      initial={{ rotate: -35 }}
      animate={{ rotate: -30 }}
      transition={
        {
          duration: 1,
          repeat: Infinity,
          repeatType: 'reverse',
        } as never
      }
      position='fixed'
      right={-4}
      top={16}
      cursor='pointer'
      onClick={onOpen}
      ref={ref}
      {...props}
    >
      <ClickBalloon width={71} height={58} mt={-16} mr={-10} />
      <Ppussung m={-8} />
      <CreditModal isOpen={isOpen} onClose={onClose} />
    </MotionFlex>
  );
});

export default CreditButtonSection;
